<template>
  <div class="avatar">
    <Modal v-show="avatarState" @close="closeAvatar">
      <template v-slot:modalBody>
        <div
          class="_fs-24 _fs-sm-20 _lh-sm-24 _lh-32 _tc-dark _mb-4 _mb-sm-2 _fw-700 _pr-sm-5"
        >
          {{ $t('cabinet.avatar.title') }}
        </div>
        <div class="_fs-20 _lh-24 _tc-dark-grey _mb-6 _fs-sm-16 _lh-sm-24">
          {{ $t('cabinet.avatar.description') }}
        </div>
        <input
          ref="inputFile"
          type="file"
          @change="croppie"
          class="user-modal__file"
        />
        <vue-croppie
          class="_mb-6"
          ref="croppieRef"
          :enableResize="false"
          :enableOrientation="true"
          :viewport="{ width: '', height: '', type: 'square' }"
          :enableZoom="true"
          :showZoomer="false"
          @result="result"
        >
        </vue-croppie>
        <div class="_fs-20 _lh-24 _tc-dark _fw-700 _mb-4">
          {{ $t('cabinet.avatar.edit') }}
        </div>
        <div class="d-md-flex d-block">
          <div class="d-flex _mr-auto">
            <div class="d-flex align-center _mr-6 _mr-sm-auto">
              <AppBtn
                @click.native="rotate(90)"
                class="_pa-0 _mr-2"
                :btnClass="'btn_grey-second'"
                ><span class="_pa-2"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C9.40092 3 7.05916 4.10172 5.41626 5.86364"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M3 3C3 2.44772 3.44772 2 4 2C4.55228 2 5 2.44772 5 3H3ZM4 7V8H3V7H4ZM8 6C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8V6ZM5 3V7H3V3H5ZM4 6H8V8H4V6Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </AppBtn>
              <span class="_fs-16 _lh-24 _tc-grey-light">{{
                $t('cabinet.avatar.left')
              }}</span>
            </div>
            <div class="d-flex align-center">
              <AppBtn
                @click.native="rotate(-90)"
                class="_pa-0 _mr-2"
                :btnClass="'btn_grey-second'"
                ><span class="_pa-2"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.5991 3 16.9408 4.10172 18.5837 5.86364"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M21 3C21 2.44772 20.5523 2 20 2C19.4477 2 19 2.44772 19 3H21ZM20 7V8H21V7H20ZM16 6C15.4477 6 15 6.44772 15 7C15 7.55228 15.4477 8 16 8V6ZM19 3V7H21V3H19ZM20 6H16V8H20V6Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </AppBtn>
              <span class="_fs-16 _lh-24 _tc-grey-light">{{
                $t('cabinet.avatar.right')
              }}</span>
            </div>
          </div>
          <AppBtn
            @click.native="upload"
            class="_pa-0 w-100 w-md-auto _mt-sm-4"
            :btnClass="'btn_secondary'"
          >
            <span class="d-flex align-center _py-2 _px-4">
              <svg
                class="_mr-1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                  stroke="#629727"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
                  stroke="#629727"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 15L16 10L5 21"
                  stroke="#629727"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="_fs-16">{{ $t('cabinet.avatar.load') }}</span>
            </span>
          </AppBtn>
        </div>
        <AppBtn class="w-100 w-md-auto _mt-6 _mt-sm-4" @click.native="crop">
          <span class="_fs-16 _py-3 _px-4">{{
            $t('cabinet.avatar.save')
          }}</span>
        </AppBtn>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import { bus } from '@/main'
import AppBtn from '../buttons/AppBtn.vue'
export default {
  components: { Modal, AppBtn },
  name: 'Avatar',
  data: () => ({
    avatarState: false,
    cropped: '',
  }),
  methods: {
    croppie(e) {
      let files = e.target.files
      if (!files.length) {
        return
      } else {
        if (!this.avatarState) {
          this.avatarState = true
          bus.$emit('scrollLock', true)
        }
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$refs.croppieRef.bind({
            url: e.target.result,
          })
        }
        reader.readAsDataURL(files[0])
      }
    },
    crop() {
      let options = {
        type: 'base64',
        format: 'jpeg' | 'png',
        size: { width: 740, height: 740 },
      }
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output
        this.sendFile()
        // this.sendCroppedImage()
      })
      this.avatarState = false
      bus.$emit('scrollLock', false)
    },
    result(output) {
      this.cropped = output
    },
    upload() {
      this.$refs.inputFile.type = ''
      this.$refs.inputFile.type = 'file'
      this.$refs.inputFile.click()
    },
    rotate(rotationAngle) {
      this.$refs.croppieRef.rotate(rotationAngle)
    },
    closeAvatar() {
      this.avatarState = false
      bus.$emit('scrollLock', false)
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async sendFile() {
      this.file = await this.dataURLtoFile(this.cropped, 'avatar.jpg')
      this.$emit('fetchFile', this.file)
    },
  },
}
</script>

<style lang="scss" scoped>
.user-modal__file {
  display: none;
}
</style>

<style>
.croppie-container .cr-boundary {
  height: 528px !important;
  width: 528px;
  margin: 0 auto;
  background: #ffffff;
}
.croppie-container .cr-viewport {
  width: 90%;
  height: 90%;
  border: 0;
}

.croppie-container .cr-viewport::before {
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  margin-top: -10px;
  margin-left: -10px;
  background-image: url('~@/assets/img/cabinet/editable_field.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: block;
  content: '';
}
@media screen and (max-width: 743px) {
  .croppie-container .cr-boundary {
    margin: 0 auto;
    height: 220px !important;
    width: 220px;
    background: #ffffff;
  }
}
</style>
